// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2e_contact_container{
  /* background:#050d3d; */
  background-image: url('https://images.openai.com/static-rsc-4/HkPW26JGvTE9GTGqdqXXcVrWsNWFvsArn_JHjLVr0CwLeKy-op73OTFTau-DBFkQ7q6AX251xHIGvY6RRxCbK4wHto08Uw7_ewHtOcbuXrxhrtvRiLJ_wGNU-2Tbsnog3YTnDlNVnh7_nzvBaBgw7q2OaCQHujIN6Qf0dOkNesQSAZlv9HbpOfn5SktTDYSx?purpose=inline');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  min-height:100vh;
  color:white;
}

.e2e_contact_header{
  text-align:center;
  padding:100px 20px;
  background:linear-gradient(
  135deg,
  #060b45,
  #1f0f74);
}

.e2e_contact_header h1{
  font-size:55px;
}

.e2e_contact_wrapper{
  display:grid;
  grid-template-columns:350px 1fr;
  gap:40px;
  padding:80px 8%;
  
}

.e2e_contact_info{
  display:flex;
  flex-direction:column;
  gap:20px;
}

.e2e_contact_card{
  background:rgba(255,255,255,.08);
  padding:25px;
  border-radius:20px;
  backdrop-filter:blur(15px);
  color: #060b45;
}

.e2e_contact_card svg{
  color:#8d39ff;
  font-size:28px;
}

.e2e_contact_form{
  background:rgba(255,255,255,.08);
  padding:40px;
  border-radius:25px;
  backdrop-filter:blur(15px);

  display:flex;
  flex-direction:column;
  gap:18px;
}

.e2e_contact_form input,
.e2e_contact_form textarea{
  border:none;
  outline:none;
  padding:16px;
  border-radius:12px;
}

.e2e_contact_form button{
  border:none;
  padding:16px;
  border-radius:12px;
  cursor:pointer;
  color:white;
  font-weight:600;

  background:linear-gradient(
  90deg,
  #8d39ff,
  #3968ff);
}

.e2e_contact_map{
  padding:0 8% 80px;
}

.e2e_contact_map iframe{
  width:100%;
  height:450px;
  border:none;
  border-radius:25px;
}

@media(max-width:768px){

.e2e_contact_wrapper{
  grid-template-columns:1fr;
}

.e2e_contact_header h1{
  font-size:40px;
}

}`, "",{"version":3,"sources":["webpack://./src/styles/contactpage.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,+QAA+Q;EAC/Q,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB;;;UAGQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,QAAQ;EACR,eAAe;;AAEjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;;EAE1B,YAAY;EACZ,qBAAqB;EACrB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;;EAEf;;;UAGQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA","sourcesContent":[".e2e_contact_container{\n  /* background:#050d3d; */\n  background-image: url('https://images.openai.com/static-rsc-4/HkPW26JGvTE9GTGqdqXXcVrWsNWFvsArn_JHjLVr0CwLeKy-op73OTFTau-DBFkQ7q6AX251xHIGvY6RRxCbK4wHto08Uw7_ewHtOcbuXrxhrtvRiLJ_wGNU-2Tbsnog3YTnDlNVnh7_nzvBaBgw7q2OaCQHujIN6Qf0dOkNesQSAZlv9HbpOfn5SktTDYSx?purpose=inline');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  min-height:100vh;\n  color:white;\n}\n\n.e2e_contact_header{\n  text-align:center;\n  padding:100px 20px;\n  background:linear-gradient(\n  135deg,\n  #060b45,\n  #1f0f74);\n}\n\n.e2e_contact_header h1{\n  font-size:55px;\n}\n\n.e2e_contact_wrapper{\n  display:grid;\n  grid-template-columns:350px 1fr;\n  gap:40px;\n  padding:80px 8%;\n  \n}\n\n.e2e_contact_info{\n  display:flex;\n  flex-direction:column;\n  gap:20px;\n}\n\n.e2e_contact_card{\n  background:rgba(255,255,255,.08);\n  padding:25px;\n  border-radius:20px;\n  backdrop-filter:blur(15px);\n  color: #060b45;\n}\n\n.e2e_contact_card svg{\n  color:#8d39ff;\n  font-size:28px;\n}\n\n.e2e_contact_form{\n  background:rgba(255,255,255,.08);\n  padding:40px;\n  border-radius:25px;\n  backdrop-filter:blur(15px);\n\n  display:flex;\n  flex-direction:column;\n  gap:18px;\n}\n\n.e2e_contact_form input,\n.e2e_contact_form textarea{\n  border:none;\n  outline:none;\n  padding:16px;\n  border-radius:12px;\n}\n\n.e2e_contact_form button{\n  border:none;\n  padding:16px;\n  border-radius:12px;\n  cursor:pointer;\n  color:white;\n  font-weight:600;\n\n  background:linear-gradient(\n  90deg,\n  #8d39ff,\n  #3968ff);\n}\n\n.e2e_contact_map{\n  padding:0 8% 80px;\n}\n\n.e2e_contact_map iframe{\n  width:100%;\n  height:450px;\n  border:none;\n  border-radius:25px;\n}\n\n@media(max-width:768px){\n\n.e2e_contact_wrapper{\n  grid-template-columns:1fr;\n}\n\n.e2e_contact_header h1{\n  font-size:40px;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
